<template>
    <table :class="tableClasses">
        <thead>
            <slot name="header" />
        </thead>
        <tbody>
            <slot />
        </tbody>
    </table>
</template>

<script>
// Mixins
import styles from '../mixins/styles.js';

export default {
    name: 'Table',
    mixins: [styles],
    computed: {
        tableClasses: function () {
            return [ this.cssClasses.pcc__table ];
        }
    },
}
</script>
